import React from 'react';
import {Button} from '@mantine/core';
import {capitalizeFirst} from '../../utils/role.utils';
import {FallbackIcon} from "@/features/auth/components/ProtectedComponent/FallbackIcon.tsx";
import {FallbackContentProps} from './FallbackContent';
import {FallbackType} from "@/features/auth/domain/auth.types.ts";

export function ButtonFallback({title, action, role, icon}: Omit<FallbackContentProps, 'type'>): React.ReactElement {
    return (
        <Button
            disabled
            color="gray"
            fullWidth
            leftSection={<FallbackIcon type={FallbackType.Button} customIcon={icon}/>}
            styles={{
                root: {
                    cursor: 'not-allowed',
                    opacity: 0.6,
                    transition: 'all 0.2s ease'
                }
            }}
        >
            {title || `${capitalizeFirst(action)} (${role}+ Required)`}
        </Button>
    );
}